import useAppState from "@dashboard/hooks/useAppState";
import { LinearProgress } from "@material-ui/core";
import { Box, Button } from "@saleor/macaw-ui-next";
import React from "react";

import { DevModePanel } from "../DevModePanel/DevModePanel";
import NavigatorSearch from "../NavigatorSearch";
import { useSavebarRef } from "../Savebar/SavebarRefContext";
import { Sidebar } from "../Sidebar";
import { useStyles } from "./styles";
import { TopNavSearch } from "./TopNav/TopNavSearch";

interface AppLayoutProps {
  children: React.ReactNode;
  fullSize?: boolean;
}

const AppLayout = ({ children }: AppLayoutProps) => {
  const classes = useStyles();
  const { setAnchor } = useSavebarRef();
  const [appState] = useAppState();

  return (
    <>
      <DevModePanel />
      <NavigatorSearch />

      <Box display="grid" __gridTemplateColumns="auto 1fr">
        {appState.loading && <LinearProgress className={classes.appLoader} color="primary" />}
        <Box
          height="100vh"
          borderColor="default1"
          borderRightWidth={1}
          backgroundColor="default2"
          borderStyle="solid"
          position="sticky"
          top={0}
          borderLeftWidth={0}
          borderTopWidth={0}
          borderBottomWidth={0}
        >
          <Sidebar />
        </Box>
        <Box height="100%" width="100%" position="relative">
          {/* Global search bar */}
          <Box 
            backgroundColor="default1"
            borderBottomWidth={1}
            borderBottomStyle="solid"
            borderColor="default1"
            paddingX={6}
            paddingY={3}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            position="sticky"
            top={0}
            __zIndex={1000}
            width="100%"
          >
            <TopNavSearch />
            <Button
              variant="secondary"
              size="medium"
              onClick={() => window.open(process.env.NEXT_PUBLIC_STOREFRONT_BASE_URL, '_blank')}
              style={{ marginLeft: '16px', flexShrink: 0 }}
            >
              Visit Storefront
            </Button>
          </Box>
          <Box as="main" width="100%" __minHeight="calc(100vh - 70px)" overflowY="auto">
            {children}
          </Box>
          <Box
            ref={setAnchor}
            position="sticky"
            bottom={0}
            left={0}
            right={0}
            backgroundColor="default1"
            borderTopWidth={1}
            borderTopStyle="solid"
            borderColor="default1"
            __zIndex={2}
          />
        </Box>
      </Box>
    </>
  );
};

export default AppLayout;
